import { useEffect } from "react";
import { useAppDispatch } from "../hooks";
import { setLastChangedFilter } from "../../appSlice";
import { setSecondaryFilterDefault } from "../../features/secondaryFilter/secondaryFilterSlice";
import { setMainFilterDefault } from "../../features/mainFilter/mainFilterSlice";
import { hideOnboarding, setMobileHomepage, setWizardDesktop } from "../../features/wizard-v2/onboardingSlice";

export default function useInitializeB2B() {
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (window.dataGlobalSettings?.siteType !== 3) return;
    $('#loginModal').on('hide.bs.modal', () => {
      if (window.location.pathname === '/') {
        // pushEvent(ONBOARDING_SKIP_HOME_EVENT, { skipFrom: 'welcome' });
        dispatch(setLastChangedFilter('what'));
        dispatch(setSecondaryFilterDefault());
        dispatch(setMainFilterDefault());
        dispatch(setWizardDesktop(false));
        dispatch(setMobileHomepage(false));
        document.getElementById('mobile-preload-container')?.remove();
        dispatch(hideOnboarding());
      }
    });
  }, [dispatch])
}
